var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakaoka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "de753156-967f-45ec-beb6-ca2cda3cc0d3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "5c34996e-c91d-4fcb-b500-c82772397795"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(26.04 0 0 26.04 1393.09 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -41.72 -10.15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(75,177,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-10.64, -8.85)",
    d: "M 18.1601 1.9881 C 18.1511 0.8891 17.2462 0 16.1337 0 C 16.0051 0 15.7162 0.0447009 15.6914 0.0491009 C 10.666 1.0454 6.33789 3.9494 3.51269 7.9681 C 3.48559 8.0083 3.45628 8.0486 3.42918 8.0865 C 3.23058 8.397 3.11328 8.7634 3.11328 9.1588 C 3.11328 9.8468 3.46299 10.4522 3.99329 10.8141 C 4.06099 10.861 15.1746 17.4531 15.1746 17.4531 C 15.4612 17.605 15.7862 17.6921 16.1337 17.6921 C 17.2326 17.6921 18.1262 16.8253 18.1578 15.7442 L 18.1601 15.7419 L 18.1601 1.9881 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -43.26 6.89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,166,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-9.09, -25.9)",
    d: "M 18.1623 24.1335 C 18.1646 24.0865 18.1691 24.0396 18.1691 23.9927 C 18.1691 23.9458 18.1646 23.8989 18.1623 23.852 C 18.1172 23.231 17.79 22.6882 17.3026 22.3486 L 17.0611 22.2056 L 3.51953 14.166 L 3.25323 14.0074 C 2.98013 13.8712 2.67333 13.793 2.34833 13.793 C 1.38703 13.793 0.583729 14.4564 0.373829 15.3455 C 0.364829 15.3924 0.355829 15.4393 0.346729 15.4885 C 0.134629 16.6277 0.0195312 17.8005 0.0195312 18.9978 C 0.0195312 28.3621 6.74643 36.1694 15.6756 37.9453 C 15.7095 37.952 16.0141 37.999 16.1359 37.999 C 17.2326 37.999 18.124 37.1367 18.1601 36.06 C 18.1601 36.0376 18.1601 35.946 18.1601 35.9215 L 18.1601 24.1335 L 18.1623 24.1335 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22.16 4.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-30.19, -23.3)",
    d: "M 36.7273 9.80499 C 36.6889 9.73799 36.6506 9.67099 36.6122 9.60169 C 36.2512 9.04989 35.6238 8.68359 34.9107 8.68359 C 34.5655 8.68359 34.2383 8.77069 33.954 8.92039 L 33.8208 9.00079 L 22.1882 15.8788 C 21.6963 16.2094 21.3601 16.7523 21.3082 17.3733 C 21.3036 17.4291 21.3082 35.8182 21.3082 35.8182 C 21.3059 35.8494 21.3059 35.9768 21.3082 36.008 C 21.3578 37.0736 22.2446 37.9224 23.3323 37.9224 C 23.4632 37.9224 23.7723 37.8733 23.8017 37.8666 C 32.5391 35.9433 39.072 28.2275 39.072 18.9995 C 39.074 15.6711 38.223 12.5392 36.7273 9.80499 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -25.61 -13.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(172,208,132)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-26.74, -5.66)",
    d: "M 31.4896 3.71203 C 31.4083 3.64063 31.3226 3.57583 31.2323 3.51993 C 29.0502 1.90263 26.5183 0.729831 23.7653 0.128931 C 23.754 0.126731 23.7405 0.124531 23.7292 0.120031 C 23.6006 0.0954314 23.4697 0.0820312 23.3343 0.0820312 C 22.2286 0.0820312 21.3327 0.957731 21.3079 2.04563 C 21.3079 2.06123 21.3057 2.07463 21.3057 2.09033 C 21.3057 2.10593 21.3079 2.11933 21.3079 2.13493 L 21.3079 9.23863 L 21.3079 9.32123 L 21.3124 9.32353 C 21.3576 10.3935 22.2444 11.2468 23.3366 11.2468 C 23.6841 11.2468 24.0135 11.1597 24.2979 11.0056 L 31.0789 6.99363 L 31.291 6.86853 C 31.8235 6.50663 32.171 5.90123 32.171 5.21323 C 32.1733 4.61453 31.9093 4.07843 31.4896 3.71203 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.64 -2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-48.71, -16.92)",
    d: "M 53.261 10.7578 C 53.417 10.7578 53.523 10.8449 53.523 11.0169 L 53.523 12.431 C 53.523 12.5873 53.419 12.6722 53.261 12.6722 L 49.759 12.6722 L 49.759 22.8295 C 49.759 23.0015 49.671 23.0887 49.515 23.0887 L 47.913 23.0887 C 47.755 23.0887 47.669 23.0015 47.669 22.8295 L 47.669 12.6722 L 44.151 12.6722 C 43.996 12.6722 43.89 12.5851 43.89 12.431 L 43.89 11.0169 C 43.89 10.8449 43.993 10.7578 44.151 10.7578 L 53.261 10.7578 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.18 -0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-56.53, -18.62)",
    d: "M 56.693 13.9492 C 58.853 13.9492 60.317 15.0192 60.317 17.4497 L 60.317 22.4848 C 60.317 22.6233 60.247 22.726 60.125 22.7774 C 59.22 23.0544 57.914 23.2956 56.623 23.2956 C 54.601 23.2956 52.737 22.5719 52.737 20.4162 C 52.737 18.5375 54.324 17.6574 56.553 17.6574 C 57.129 17.6574 57.772 17.7267 58.295 17.7959 L 58.295 17.4675 C 58.295 16.2434 57.842 15.7251 56.553 15.7251 C 55.682 15.7251 54.881 15.9485 54.324 16.2769 C 54.202 16.364 54.062 16.3461 53.976 16.2076 L 53.279 15.1555 C 53.191 15.017 53.191 14.9321 53.279 14.8629 C 54.116 14.2955 55.283 13.9492 56.693 13.9492 Z M 56.625 21.5555 C 57.201 21.5555 57.862 21.4527 58.297 21.3477 L 58.297 19.3998 C 57.828 19.3306 57.147 19.2613 56.607 19.2613 C 55.301 19.2613 54.777 19.6924 54.777 20.4006 C 54.777 21.2092 55.563 21.5555 56.625 21.5555 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.59 -2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-65.95, -16.92)",
    d: "M 67.762 23.0887 C 67.622 23.0887 67.5 23.0552 67.43 22.9345 L 64.695 19.3827 L 64.086 20.0037 L 64.086 22.8318 C 64.086 23.0038 63.998 23.0909 63.824 23.0909 L 62.326 23.0909 C 62.152 23.0909 62.064 23.0038 62.064 22.8318 L 62.064 11.0169 C 62.064 10.8449 62.152 10.7578 62.326 10.7578 L 63.824 10.7578 C 63.998 10.7578 64.086 10.8449 64.086 11.0169 L 64.086 17.5711 L 67.153 14.2761 C 67.241 14.1734 67.326 14.1555 67.466 14.1555 L 69.26 14.1555 C 69.486 14.1555 69.538 14.294 69.4 14.4481 L 66.038 17.9843 L 69.766 22.7782 C 69.887 22.9502 69.836 23.0887 69.61 23.0887 L 67.762 23.0887 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.59 -0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-73.94, -18.62)",
    d: "M 74.103 13.9492 C 76.262 13.9492 77.727 15.0192 77.727 17.4497 L 77.727 22.4848 C 77.727 22.6233 77.657 22.726 77.535 22.7774 C 76.63 23.0544 75.324 23.2956 74.033 23.2956 C 72.011 23.2956 70.149 22.5719 70.149 20.4162 C 70.149 18.5375 71.734 17.6574 73.963 17.6574 C 74.538 17.6574 75.182 17.7267 75.705 17.7959 L 75.705 17.4675 C 75.705 16.2434 75.252 15.7251 73.963 15.7251 C 73.092 15.7251 72.291 15.9485 71.734 16.2769 C 71.612 16.364 71.472 16.3461 71.384 16.2076 L 70.686 15.1555 C 70.598 15.017 70.598 14.9321 70.686 14.8629 C 71.524 14.2955 72.693 13.9492 74.103 13.9492 Z M 74.033 21.5555 C 74.608 21.5555 75.27 21.4527 75.705 21.3477 L 75.705 19.3998 C 75.236 19.3306 74.554 19.2613 74.015 19.2613 C 72.708 19.2613 72.185 19.6924 72.185 20.4006 C 72.187 21.2092 72.97 21.5555 74.033 21.5555 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.98 -0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-83.33, -18.62)",
    d: "M 83.334 23.2956 C 80.931 23.2956 79.363 21.9509 79.363 19.8131 L 79.363 17.501 C 79.363 15.3275 80.931 13.9492 83.334 13.9492 C 85.738 13.9492 87.306 15.3297 87.306 17.501 L 87.306 19.8131 C 87.306 21.9509 85.738 23.2956 83.334 23.2956 Z M 83.334 21.5019 C 84.571 21.5019 85.268 20.9166 85.268 19.8131 L 85.268 17.501 C 85.268 16.3618 84.571 15.743 83.334 15.743 C 82.08 15.743 81.4 16.364 81.4 17.501 L 81.4 19.8131 C 81.4 20.9166 82.08 21.5019 83.334 21.5019 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 40.46 -2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-92.82, -16.92)",
    d: "M 94.63 23.0887 C 94.491 23.0887 94.369 23.0552 94.299 22.9345 L 91.564 19.3827 L 90.955 20.0037 L 90.955 22.8318 C 90.955 23.0038 90.867 23.0909 90.693 23.0909 L 89.194 23.0909 C 89.021 23.0909 88.933 23.0038 88.933 22.8318 L 88.933 11.0169 C 88.933 10.8449 89.021 10.7578 89.194 10.7578 L 90.693 10.7578 C 90.867 10.7578 90.955 10.8449 90.955 11.0169 L 90.955 17.5711 L 94.021 14.2761 C 94.109 14.1734 94.195 14.1555 94.335 14.1555 L 96.129 14.1555 C 96.354 14.1555 96.406 14.294 96.269 14.4481 L 92.906 17.9843 L 96.634 22.7782 C 96.756 22.9502 96.704 23.0887 96.479 23.0887 L 94.63 23.0887 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 48.54 -0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-100.89, -18.62)",
    d: "M 101.057 13.9492 C 103.217 13.9492 104.681 15.0192 104.681 17.4497 L 104.681 22.4848 C 104.681 22.6233 104.611 22.726 104.49 22.7774 C 103.585 23.0544 102.278 23.2956 100.987 23.2956 C 98.965 23.2956 97.102 22.5719 97.102 20.4162 C 97.102 18.5375 98.688 17.6574 100.917 17.6574 C 101.493 17.6574 102.136 17.7267 102.659 17.7959 L 102.659 17.4675 C 102.659 16.2434 102.206 15.7251 100.917 15.7251 C 100.046 15.7251 99.245 15.9485 98.688 16.2769 C 98.566 16.364 98.426 16.3461 98.34 16.2076 L 97.643 15.1555 C 97.555 15.017 97.555 14.9321 97.643 14.8629 C 98.478 14.2955 99.647 13.9492 101.057 13.9492 Z M 100.987 21.5555 C 101.563 21.5555 102.224 21.4527 102.659 21.3477 L 102.659 19.3998 C 102.188 19.3306 101.509 19.2613 100.969 19.2613 C 99.663 19.2613 99.142 19.6924 99.142 20.4006 C 99.142 21.2092 99.925 21.5555 100.987 21.5555 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.68 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-48.67, -28.46)",
    d: "M 46.672 30.9525 C 46.636 30.9525 46.616 30.9257 46.629 30.8832 L 48.432 26.0179 C 48.446 25.9911 48.468 25.9688 48.495 25.9688 L 48.847 25.9688 C 48.875 25.9688 48.897 25.9889 48.911 26.0179 L 50.72 30.8832 C 50.727 30.9234 50.714 30.9525 50.671 30.9525 L 50.382 30.9525 C 50.346 30.9525 50.325 30.9324 50.312 30.9033 L 49.797 29.496 L 47.545 29.496 L 47.031 30.9033 C 47.017 30.9301 46.995 30.9525 46.968 30.9525 L 46.672 30.9525 Z M 47.665 29.1408 L 49.678 29.1408 L 48.685 26.4155 L 48.665 26.4155 L 47.665 29.1408 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.76 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-56.11, -28.46)",
    d: "M 54.358 30.9525 C 54.322 30.9525 54.301 30.9324 54.301 30.8966 L 54.301 26.0246 C 54.301 25.9889 54.322 25.9688 54.358 25.9688 L 54.667 25.9688 C 54.694 25.9688 54.723 25.9822 54.737 26.0112 L 57.054 29.5652 C 57.217 29.8221 57.393 30.1014 57.539 30.3605 L 57.553 30.3404 C 57.539 29.7618 57.526 29.0649 57.526 28.4863 L 57.526 26.0246 C 57.526 25.9889 57.553 25.9688 57.589 25.9688 L 57.858 25.9688 C 57.894 25.9688 57.914 25.9889 57.914 26.0246 L 57.914 30.8966 C 57.914 30.9324 57.894 30.9525 57.858 30.9525 L 57.548 30.9525 C 57.521 30.9525 57.492 30.9391 57.479 30.9167 L 55.141 27.3627 C 54.985 27.1259 54.818 26.84 54.676 26.5965 L 54.669 26.6032 C 54.676 27.1192 54.689 27.8228 54.689 28.3389 L 54.689 30.8966 C 54.689 30.9324 54.662 30.9525 54.626 30.9525 L 54.358 30.9525 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.24 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-63.59, -28.46)",
    d: "M 62.472 30.5973 L 65.036 30.5973 C 65.072 30.5973 65.092 30.6174 65.092 30.6531 L 65.092 30.8966 C 65.092 30.9324 65.072 30.9525 65.036 30.9525 L 62.143 30.9525 C 62.107 30.9525 62.086 30.9324 62.086 30.8966 L 62.086 26.0246 C 62.086 25.9889 62.107 25.9688 62.143 25.9688 L 64.932 25.9688 C 64.975 25.9688 64.995 25.9889 64.995 26.0246 L 64.995 26.2681 C 64.995 26.3038 64.975 26.3239 64.932 26.3239 L 62.475 26.3239 L 62.475 28.2339 L 64.783 28.2339 C 64.819 28.2339 64.839 28.254 64.839 28.2964 L 64.839 28.5332 C 64.839 28.569 64.819 28.5891 64.783 28.5891 L 62.475 28.5891 L 62.475 30.5973 L 62.472 30.5973 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.06 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-70.41, -28.46)",
    d: "M 70.411 31.0279 C 69.707 31.0279 69.215 30.8112 68.664 30.3667 C 68.637 30.3399 68.637 30.3109 68.658 30.284 L 68.804 30.083 C 68.825 30.0562 68.854 30.0473 68.89 30.0696 C 69.382 30.4672 69.84 30.6616 70.418 30.6683 C 71.192 30.6683 71.79 30.3399 71.79 29.6653 C 71.79 29.0599 71.347 28.8142 70.345 28.593 C 69.366 28.3696 68.669 27.9876 68.669 27.15 C 68.669 26.2855 69.463 25.8945 70.386 25.8945 C 71.027 25.8945 71.528 26.0822 72.027 26.453 C 72.063 26.4731 72.054 26.5088 72.04 26.5379 L 71.9 26.7345 C 71.88 26.7702 71.844 26.7769 71.814 26.7546 C 71.379 26.4262 70.892 26.2654 70.343 26.2586 C 69.639 26.2586 69.061 26.5513 69.061 27.1656 C 69.061 27.7576 69.56 28.0167 70.433 28.2177 C 71.553 28.4813 72.18 28.8164 72.18 29.6675 C 72.187 30.5767 71.426 31.0279 70.411 31.0279 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 24.87 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-77.22, -28.46)",
    d: "M 78.992 25.9688 C 79.029 25.9688 79.056 25.9889 79.056 26.0246 L 79.056 26.2681 C 79.056 26.3038 79.029 26.3239 78.992 26.3239 L 77.408 26.3239 L 77.408 30.8966 C 77.408 30.9324 77.381 30.9525 77.345 30.9525 L 77.079 30.9525 C 77.043 30.9525 77.016 30.9324 77.016 30.8966 L 77.016 26.3239 L 75.445 26.3239 C 75.409 26.3239 75.389 26.3038 75.389 26.2681 L 75.389 26.0246 C 75.389 25.9889 75.409 25.9688 75.445 25.9688 L 78.992 25.9688 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.8 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-84.15, -28.46)",
    d: "M 83.039 30.5973 L 85.6 30.5973 C 85.636 30.5973 85.656 30.6174 85.656 30.6531 L 85.656 30.8966 C 85.656 30.9324 85.636 30.9525 85.6 30.9525 L 82.707 30.9525 C 82.671 30.9525 82.65 30.9324 82.65 30.8966 L 82.65 26.0246 C 82.65 25.9889 82.671 25.9688 82.707 25.9688 L 85.496 25.9688 C 85.537 25.9688 85.559 25.9889 85.559 26.0246 L 85.559 26.2681 C 85.559 26.3038 85.539 26.3239 85.496 26.3239 L 83.039 26.3239 L 83.039 28.2339 L 85.347 28.2339 C 85.383 28.2339 85.403 28.254 85.403 28.2964 L 85.403 28.5332 C 85.403 28.569 85.383 28.5891 85.347 28.5891 L 83.039 28.5891 L 83.039 30.5973 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 38.63 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-90.98, -28.46)",
    d: "M 90.977 31.0279 C 90.273 31.0279 89.779 30.8112 89.231 30.3667 C 89.204 30.3399 89.204 30.3109 89.224 30.284 L 89.371 30.083 C 89.391 30.0562 89.42 30.0473 89.456 30.0696 C 89.948 30.4672 90.406 30.6616 90.984 30.6683 C 91.758 30.6683 92.356 30.3399 92.356 29.6653 C 92.356 29.0599 91.912 28.8142 90.912 28.593 C 89.933 28.3696 89.235 27.9876 89.235 27.15 C 89.235 26.2855 90.03 25.8945 90.952 25.8945 C 91.593 25.8945 92.094 26.0822 92.593 26.453 C 92.629 26.4731 92.62 26.5088 92.607 26.5379 L 92.467 26.7345 C 92.446 26.7702 92.41 26.7769 92.381 26.7546 C 91.945 26.4262 91.458 26.2654 90.91 26.2586 C 90.206 26.2586 89.628 26.5513 89.628 27.1656 C 89.628 27.7576 90.129 28.0167 91.002 28.2177 C 92.121 28.4813 92.749 28.8164 92.749 29.6675 C 92.751 30.5767 91.991 31.0279 90.977 31.0279 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 44.42 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-96.77, -28.46)",
    d: "M 96.966 30.8966 C 96.966 30.9324 96.946 30.9525 96.91 30.9525 L 96.635 30.9525 C 96.598 30.9525 96.578 30.9324 96.578 30.8966 L 96.578 26.0246 C 96.578 25.9889 96.598 25.9688 96.635 25.9688 L 96.91 25.9688 C 96.946 25.9688 96.966 25.9889 96.966 26.0246 L 96.966 30.8966 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 50.25 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,74,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-102.6, -28.46)",
    d: "M 100.597 30.9525 C 100.561 30.9525 100.541 30.9257 100.555 30.8832 L 102.358 26.0179 C 102.371 25.9911 102.394 25.9688 102.421 25.9688 L 102.773 25.9688 C 102.8 25.9688 102.822 25.9889 102.836 26.0179 L 104.646 30.8832 C 104.652 30.9234 104.639 30.9525 104.596 30.9525 L 104.307 30.9525 C 104.271 30.9525 104.251 30.9324 104.237 30.9033 L 103.723 29.496 L 101.471 29.496 L 100.956 30.9033 C 100.943 30.9301 100.92 30.9525 100.893 30.9525 L 100.597 30.9525 Z M 101.59 29.1408 L 103.603 29.1408 L 102.61 26.4155 L 102.59 26.4155 L 101.59 29.1408 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakaoka);
export default __webpack_public_path__ + "static/media/takaoka.4413acca7c5c82c23f70382565674a99.svg";
export { ForwardRef as ReactComponent };